import { render, staticRenderFns } from "./OpenTextList.vue?vue&type=template&id=08f49448&scoped=true&"
import script from "./OpenTextList.vue?vue&type=script&lang=js&"
export * from "./OpenTextList.vue?vue&type=script&lang=js&"
import style0 from "./OpenTextList.vue?vue&type=style&index=0&id=08f49448&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f49448",
  null
  
)

export default component.exports